<template>
	<div id='course' :class="[theme, padding === 'zero' ? 'no-padding' : '', fontSize]">
		<div v-if="!errorPageShow">
			<h1 class="title">{{$route.query.title}}</h1>
			<p class="time">
				<span>{{time | parseTime('{y}-{m}-{d} {h}:{i}:{s}')}}</span>
			</p>
			<div class="content" ref="contentRef" v-html="content"></div>
		</div>
		<div v-else class="error-page">
			<img :src="httpImg+`/activeXP/default.svg`" alt="">
			<h2>{{ this.$t('common.xp_network') }}</h2>
			<div class="reload" type="primary" @click="reload">{{ this.$t('common.refresh') }}</div>
		</div>
		<!--  -->
		<div v-if="showLoading" class="load">
			<div class="img">
				<img :src="httpImg + `/activeXP/loading.svg`" alt="">
				{{ this.$t('common.load') }}
			</div>
		</div>
	</div>
</template>

<script>
	import {
		mapState,
		mapActions
	} from 'vuex';
	export default {
		name: 'Course',
		components: {},
		data() {
			return {
				id: 6,
				active: {},
				content: null,
				time: null,
				theme: 'day',
				fontSize: '',
				padding: '',
				errorPageShow: false,
				showLoading: false
			}
		},
		computed: {
			//获取用户信息
			...mapState('app', {
				theme: state => state.theme,
				httpImg: state => state.httpImg
			}),
		},
		mounted() {
			this.theme = this.$route.query.theme
			this.fontSize = this.$route.query.font
			this.id = this.$route.query.id;
			document.title = `XP ${this.$t('activity.course')}-` + this.$route.query.title;
			// this.courseId = 27
			this.showLoading = true;
			this.getCourse()
			window.changeFontSize = (type) => {
				this.fontSize = type
			}
			window.changeTheme = (theme) => {
				this.theme = theme
			}
		},
		watch: {
			$route: {
				handler(newVal) {
					location.reload();
				},
				deep: true
			}
		},
		methods: {
			getCourse() {
				// let type = this.newsType;
				this.$MyAxios.getText(`/api/materials/${this.id}`, {},
					response => {
						this.showLoading = false
						if (response) {
							let regex = new RegExp('<img', 'g')
							let content = response.data.content
							if (!content) {
								this.errorPageShow = true
								// this.content = '<h1 style="text-align: center;">欧呦！该教程什么内容都没有！</h1>'
								return
							}
							let result = content.match(regex)
							let count = !result ? 0 : result.length
							if (count === 1) {
								this.padding = 'zero'
							} else {
								this.padding = ''
							}
							this.content = content
							this.time = response.data.timestamp
							this.getAllImg()
							this.errorPageShow = false
						} else {
							this.errorPageShow = true
						}
					},
					error => {
						this.showLoading = false
						this.errorPageShow = true
						// this.content = '<h1 style="text-align: center;">欧呦！获取教程失败！</h1>'
					}
				)
			},

			getAllImg() {
				setTimeout(() => {
					const imgNodes = this.$refs.contentRef.getElementsByTagName('img')
					const imgUrlList = []
					imgNodes.forEach((img, index) => {
						imgUrlList.push(img.getAttribute('src'))
					})
					const self = this
					imgNodes.forEach((img, index) => {
						console.log(img)
						img.onclick = function(img, index) {
							return function() {
								self.setAppImg(index, imgUrlList)
							}

						}(img, index)
					})
					// console.log(imgUrlList)
					// this.setAppImg(imgUrlList)
				}, 0);
			},

			setAppImg(currentIndex, list) {
				this.$setupWebViewJavascriptBridge(function(bridge) {
					bridge.callHandler('handleSetImgUrlList', {
						data: {
							currentIndex,
							list
						}
					});
				});

				if (window.androidHandler) {
					let str = JSON.stringify({
						params: 'ImgUrlList',
						data: {
							currentIndex,
							list
						}
					});
					androidHandler.setValue(str);
				}
			},
			reload() {
				this.showLoading = true
				this.getCourse()
			}
		}
	}
</script>

<style scoped lang='less'>
	@keyframes rotateZ {
		0% {
			transform: rotateZ(0deg);
		}

		100% {
			transform: rotateZ(360deg);
		}
	}

	.load {
		width: 100%;
		height: 100%;
		position: fixed;
		left: 0;
		top: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		background: rgba(0, 0, 0, 0.5);

		.img {
			padding: 4vw 14vw;
			background: #fff;
			border-radius: 3vw;
			font-size: 3.7vw;
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;
			color: #666;
		}

		img {
			width: 10vw;
			height: 10vw;
			margin-bottom: 2vw;
			animation: rotateZ 4s linear 0s infinite;
		}
	}

	#course {
		min-height: 100vh;
		background: white;
		text-align: left;
		padding: 1.25rem 1.5625rem;

		&.no-padding {
			// padding: 0;
		}

		* {
			box-sizing: border-box;
		}

		overflow: hidden;
		position: relative;

		&.night {
			background: #181820;
		}

		h1.title {
			font-size: 38px;
			line-height: 57px;
			color: #33333A;
			font-weight: bold;
		}

		p.time {
			font-size: 24px;
			color: #9598A6;
		}

		.error-page {
			padding-top: 30px;
			text-align: center;

			img {
				width: 300px;
				height: 300px;
				margin: 0 auto;
				margin-top: 180px;
			}

			h2 {
				font-size: 34px;
				color: #33333A;
				margin: 20px 0 40px 0;
			}
		}

		.reload {
			background: #1E2329;
			height: 88px;
			width: 600px;
			border-radius: 16px;
			color: #ffffff;
			text-align: center;
			line-height: 88px;
			margin: 180px auto 0 auto;
			font-size: 28px;
		}

		h2 {
			font-size: 1.1875rem;
			color: #4B4D59;
			font-weight: bold;
			line-height: 1.5;
		}

		h1 {
			line-height: 1.5;
		}

		&.night h2 {
			color: #E3E3E1;
		}

		&.night span {
			color: #9D9DA6;
		}

		font-family: PingFang SC,
		Lantinghei SC,
		Helvetica Neue,
		Helvetica,
		Arial,
		Microsoft YaHei,
		\\\5FAE\8F6F\96C5\9ED1,
		STHeitiSC-Light,
		simsun,
		\\\5B8B\4F53,
		WenQuanYi Zen Hei,
		WenQuanYi Micro Hei,
		sans-serif;

		p {
			font-size: 1rem;
			color: #29293b;
			line-height: 2rem;
			text-align: justify;
			word-break: break-all;
		}

		&.night p {
			color: #E3E3E1;
			background: #181820;
		}

		a {
			font-size: 1rem;
		}

		strong {
			font-size: 1.2rem;
			margin-top: 1.5rem;
			display: block;
		}

		blockquote {
			display: block;
			border-left: 8px solid #d0e5f2;
			padding: 5px 10px;
			margin: 10px 0;
			line-height: 1.4;
			font-size: 100%;
			background-color: #f1f1f1;
		}

		video {
			width: 100%;
		}

		iframe {
			width: 100%;
			height: 90vh;
		}

		table {
			border-top: 1px solid #ccc;
			border-left: 1px solid #ccc;
		}

		table td,
		table th {
			border-bottom: 1px solid #ccc;
			border-right: 1px solid #ccc;
			padding: 3px 5px;
			min-height: 30px;
		}

		table th {
			border-bottom: 2px solid #ccc;
			text-align: center;
			background-color: #f1f1f1;
		}

		&.night h1,
		&.night h2,
		&.night h3,
		&.night h4,
		&.night h5,
		&.night h6,
		&.night li {
			color: #E3E3E1;
			background: #181820;
		}

		ul li {
			overflow: hidden;
			display: -ms-flexbox;
			-webkit-line-clamp: 2
		}

		li {
			line-height: 1.8rem;
		}

		ul {
			margin-bottom: 1.5rem;
		}

		.content {
			img {
				width: 100%;
			}
		}
	}

	#course.big {
		h1.title {
			font-size: 42px;
			line-height: 60px;
		}

		p.time {
			font-size: 28px;
		}

		h2 {
			font-size: 1.3rem;
			line-height: 1.6;
		}

		p {
			font-size: 1.15rem;
			line-height: 2rem;
		}

		a {
			font-size: 1.15;
		}

		strong {
			font-size: 1.3rem;
		}

		blockquote {
			line-height: 1.5;
		}
	}

	#course.small {
		h1.title {
			font-size: 34px;
			line-height: 54px;
		}

		p.time {
			font-size: 20px;
		}

		h2 {
			font-size: 1rem;
			line-height: 1.2;
		}

		p {
			font-size: 0.8rem;
			line-height: 1.4rem;
		}

		a {
			font-size: 0.8;
		}

		strong {
			font-size: 1.1rem;
		}

		blockquote {
			line-height: 1.2;
		}
	}
</style>